import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../../shared/constants/routes";
import { formatNumber } from "../../../shared/utils/format";
import type { CheatsheetListItem } from "../types";

interface CheatSheetCardProps {
    cheatsheet: CheatsheetListItem;
    courseId?: string | number;
}

const CheatSheetCard = ({ cheatsheet, courseId }: CheatSheetCardProps) => {
    const { lang } = useLanguage();

    // The title lives in the translation. Without one there is nothing to show.
    const translation = cheatsheet.translations[0];
    if (!translation || courseId === undefined) return null;

    return (
        <Link
            to={ROUTES.myCourseCheatsheetItem(lang, courseId, cheatsheet.id)}
            className="block"
        >
            <div className="bg-white border border-gray-200 rounded-xl p-5 transition duration-200 hover:border-gray-300 hover:shadow-md hover:-translate-y-0.5">
                <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center">
                        <FontAwesomeIcon icon={faBookOpen} className="text-gray-700 text-lg" />
                    </div>

                    <div className="flex-1 min-w-0">
                        <h3 className="font-semibold text-gray-900 text-lg">{translation.title}</h3>

                        {translation.subtitle && (
                            <p className="mt-1 text-sm text-gray-500 leading-6">
                                {translation.subtitle}
                            </p>
                        )}
                    </div>

                    {cheatsheet.position !== undefined && (
                        <div className="text-gray-400 text-sm">
                            #{formatNumber(cheatsheet.position, lang)}
                        </div>
                    )}
                </div>
            </div>
        </Link>
    );
};

export default CheatSheetCard;